import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CLUSTERS, Conference } from '../../../shared';

@Component({
  selector: 'app-booking-confirmation',
  templateUrl: 'booking-confirmation.component.html'
})
export class BookingConfirmationComponent {
    @Input() 
    conference: Conference;
    @Input()
    currentClusterName: string;
    @Output()
    conferenceConfirmed: EventEmitter<boolean> = new EventEmitter()
    
    clusters;
    notifyTeam: boolean;

    constructor() {
        this.clusters = CLUSTERS;
    }

    onConfirmed() {
        this.conferenceConfirmed.emit(this.notifyTeam);
    }

    public isAbleToNotify(): boolean {
        return this.currentClusterName === CLUSTERS.VA.LIGHT || this.currentClusterName === CLUSTERS.IL;
    }
}


// WEBPACK FOOTER //
// ./src/app/hunt/components/booking-confirmation/booking-confirmation.component.ts